import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import useService from "../../../../../../hooks/useService";
import ShowMoreButton from "../../../../../modules/Common/ShowMoreButton";

import SearchWithParams from "./../../../../../modules/Common/SearchWithParams/index";
import CallLogPanel from "./components/CallLogPanel";

export default function CallLog() {
  const { _clientId } = useLoaderData();
  const callLogRepository = useService("repositories/case-call-log-repository");
  const { filters } = useQueryParams();
  const limit = Number(filters.get("callLogLimit")) || 20;
  const search = filters.get("callLogSearch") || undefined;
  const [callList, setCallList] = useState([]);
  const [showMore, setShowMore] = useState(false);

  async function getData() {
    try {
      const resp = await callLogRepository.query({
        user__in: _clientId,
        search,
        limit,
        skipNull: true,
      });
      const showMore = callLogRepository.getTotalCount() >= limit;
      setCallList(resp);
      setShowMore(showMore);
    } catch (error) {
      console.error("Error fetching call log:", error);
      return error;
    }
  }

  useEffect(() => {
    getData();
  }, [_clientId, search, limit]);

  return (
    <div data-testid="Call-Log">
      <CallLogPanel>
        <CallLogPanel.Header />
        <SearchWithParams queryKey="callLogSearch" label="Search Call History" />
        <CallLogPanel.List callLogList={callList} />
        <ShowMoreButton showMoreAmt={5} showMoreVisible={showMore} queryKey="callLogLimit" />
      </CallLogPanel>
    </div>
  );
}
